import { Institution } from '../../types/routes/accountManagement';

export const displayName = (inst: Institution): string => inst.nickName || inst.externalName;

export const institutionSortOrder = <T extends Institution>(x: T, y: T): number =>
  displayName(x).toLowerCase().localeCompare(displayName(y).toLowerCase());
